module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('loading'), _c('div', {
    staticClass: "loginpage"
  }, [_vm._m(0), _c('router-view'), _c('footer-row')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-embossed navbar-custom",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('img', {
    staticClass: "header-logo",
    attrs: {
      "src": require("../../assets/racooo_logo_white.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58dc0357","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Layout.vue
// module id = 601
// module chunks = 1